import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const {
    cid,
    aid,
  } = descriptor;

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid);

  return `${entity.path}/Ads/Default.EditorialReasons`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function odataPayloadFactory(params) {
  const { variables } = params;
  const { data } = variables;

  return data;
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:editorial_reasons',
  verb: requestVerbs.POST,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  payloadFactoryFn: odataPayloadFactory,
  keySelector: editorialReasons => editorialReasons.EntityId,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: editorialReasons => editorialReasons.EntityId,
  processorFn: response => response.value,
});
